import Vue from 'vue';

Vue.component('measurement-index', () =>
    import(/* webpackChunkName: 'measurement-index' */ './measurement-index.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory-fnb/measurement/index.js